import Tempus from "@darkroom.engineering/tempus";
import { lerp } from "@/js/helpers";

import { module as modujs } from "modujs";

export default class extends modujs {
	constructor(m) {
		super(m);
	}

	init() {
		this.initCache();
		this.initEvents();
		this.initMarquee();

		this.render();
	}

	initCache() {
		/* DOMs */
		this.DOM = {};
		this.DOM.inner = Array.from(this.$("inner"))[0];

		/* CONFIG */
		this.lerp = { current: 0, target: 0 };
		this.interpolationFactor = 0.05;
		this.speed = 0.02;
		this.directionScroll = -1;
		this.lastScrollTop = 0;
		this.multiplier = 0.005;
		this.prevDirectionScroll = 1;

		this.lenis = window.prtx.lenisInstance;
		this.handleScroll = this.onScroll.bind(this);
	}

	initEvents() {
		this.lenis.on("scroll", this.handleScroll);
	}

	initMarquee() {
		this.DOM.inner.style.cssText = `position: relative; display: inline-flex; white-space: nowrap; will-change: transform; backface-visibility: hidden;`;
		this.DOM.inner.children[1].style.cssText = `position: absolute; left: -100%;`;
		this.DOM.inner.children[2].style.cssText = `position: absolute; left: 100%;`;
	}

	render() {
		this.updater = Tempus.add((time) => {
			this.update();
		});
	}

	onScroll({ direction, velocity }) {
		this.directionScroll = direction ? -direction : this.prevDirectionScroll;
		this.multiplier = 1 + Math.abs(velocity / 2);

		this.prevDirectionScroll = this.directionScroll;
	}

	update() {
		this.lerp.target += this.speed * this.directionScroll * this.multiplier;
		this.lerp.current = lerp(this.lerp.current, this.lerp.target, this.interpolationFactor);

		if (this.lerp.target > 100 || this.lerp.target < -100) {
			this.lerp.current -= this.lerp.target;
			this.lerp.target = 0;
		}

		this.DOM.inner.style.transform = `translate3d(${this.lerp.current}%, 0, 0)`;

		this.multiplier = 1;
	}

	destroy() {
		this.updater();
	}
}
